"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _userflow = require("../../utils/userflow");
var _Button = _interopRequireDefault(require("../Button"));
var _easing = _interopRequireDefault(require("../ScrollCarousel/easing"));
var _ChevronRight = _interopRequireDefault(require("../../icons-react/rebrand/ChevronRight"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Slider = /*#__PURE__*/function (_React$PureComponent) {
  function Slider(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Slider);
    _this = _callSuper(this, Slider, [props]);
    _this.state = {
      slide: 0,
      slidesCount: 0,
      scrollable: false,
      disabledControl: 'prev'
    };

    // In case of SSR this shoud be placed in componentDidMount w/ rerender
    _this.events = (0, _userflow.makeTouchDependableEvents)();
    _this.onArrowClick = _this.onArrowClick.bind(_this);
    _this.onDotClick = _this.onDotClick.bind(_this);
    _this.syncScroll = _this.syncScroll.bind(_this);
    _this.sliderRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  (0, _inherits2["default"])(Slider, _React$PureComponent);
  return (0, _createClass2["default"])(Slider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var dots = this.props.dots;
      var rendered = function rendered() {
        if (!dots && !_this2.sliderRef.current) {
          return null;
        }
        var _this2$sliderRef$curr = _this2.sliderRef.current,
          clientWidth = _this2$sliderRef$curr.clientWidth,
          scrollWidth = _this2$sliderRef$curr.scrollWidth;
        if (scrollWidth > clientWidth) {
          _this2.checkScrollAbility();
        }
        window.requestAnimationFrame(rendered);
        return null;
      };
      rendered();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var prevChildren = _ref.children;
      var children = this.props.children;
      if (prevChildren !== children) {
        this.checkScrollAbility();
      }
    }
  }, {
    key: "onArrowClick",
    value: function onArrowClick(e) {
      var _this3 = this;
      (0, _userflow.unlessLocked)(this, e, function () {
        var direction = e.currentTarget.dataset.direction;
        var width = _this3.sliderRef.current.clientWidth * direction;
        _this3.diffScroll(width, true);
      });
    }
  }, {
    key: "onDotClick",
    value: function onDotClick(e) {
      var _this4 = this;
      (0, _userflow.unlessLocked)(this, e, function () {
        var index = e.currentTarget.dataset.index;
        _this4.scrollToSlide(index);
      });
    }
  }, {
    key: "checkScrollAbility",
    value: function checkScrollAbility() {
      var _this$sliderRef$curre = this.sliderRef.current,
        clientWidth = _this$sliderRef$curre.clientWidth,
        scrollWidth = _this$sliderRef$curre.scrollWidth;
      return this.setState({
        slidesCount: Math.ceil(scrollWidth / clientWidth),
        scrollable: scrollWidth > clientWidth
      });
    }
  }, {
    key: "scrollToSlide",
    value: function scrollToSlide(index) {
      var _this$sliderRef$curre2 = this.sliderRef.current,
        scrollLeft = _this$sliderRef$curre2.scrollLeft,
        clientWidth = _this$sliderRef$curre2.clientWidth;
      var nextSlideOffset = clientWidth * Number(index);
      var diff = nextSlideOffset - scrollLeft;
      this.diffScroll(diff, true);
    }
  }, {
    key: "syncDot",
    value: function syncDot(node) {
      var offsetWidth = node.offsetWidth,
        scrollLeft = node.scrollLeft;
      var slide = Math.ceil(scrollLeft / offsetWidth);
      this.setState({
        slide: slide
      });
    }
  }, {
    key: "syncControlsVisibility",
    value: function syncControlsVisibility(node) {
      var disabledControl = null;
      var offsetWidth = node.offsetWidth,
        scrollLeft = node.scrollLeft,
        scrollWidth = node.scrollWidth;
      var isEnd = scrollWidth - (scrollLeft + offsetWidth) === 0;
      if (scrollLeft <= 0) {
        disabledControl = 'prev';
      } else if (isEnd) {
        disabledControl = 'next';
      }
      this.setState({
        disabledControl: disabledControl
      });
    }
  }, {
    key: "diffScroll",
    value: function diffScroll(diff) {
      var _this5 = this;
      var animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var scrollable = this.sliderRef.current;
      var _this$props = this.props,
        duration = _this$props.duration,
        easing = _this$props.easing;
      var scrollLeft = scrollable.scrollLeft;
      if (animate) {
        this.animate(duration, easing, diff, function (d) {
          scrollable.scrollLeft += Math.floor(d);
        }, function () {
          scrollable.scrollLeft = scrollLeft + diff;
          _this5.syncScroll();
        });
      } else {
        scrollable.scrollLeft += diff;
        this.syncScroll();
      }
    }
  }, {
    key: "animate",
    value: function animate(duration, easing, value, clb, endClb) {
      _easing["default"].ease({
        easing: easing,
        duration: duration,
        length: value,
        animate: clb.bind(this),
        end: endClb instanceof Function ? endClb.bind(this) : null
      });
    }

    // EVENT HANDLERS
  }, {
    key: "syncScroll",
    value: function syncScroll(ev) {
      var node = ev && ev.currentTarget || this.sliderRef.current;
      this.syncDot(node);
      this.syncControlsVisibility(node);
    }

    // RENDERS
  }, {
    key: "renderControls",
    value: function renderControls() {
      var _this$props2 = this.props,
        dots = _this$props2.dots,
        controls = _this$props2.controls;
      var disabledControl = this.state.disabledControl;
      var attrs = (0, _defineProperty2["default"])({}, this.events.get('click'), this.onArrowClick);
      return /*#__PURE__*/_react["default"].createElement(ControlsContainer, null, controls && /*#__PURE__*/_react["default"].createElement(StyledControlsButton, (0, _extends2["default"])({
        "data-direction": -1,
        disabled: disabledControl === 'prev'
      }, attrs), /*#__PURE__*/_react["default"].createElement(StyledChevronIcon, {
        $isRotated: true
      })), dots && this.renderDots(), controls && /*#__PURE__*/_react["default"].createElement(StyledControlsButton, (0, _extends2["default"])({
        "data-direction": 1,
        disabled: disabledControl === 'next'
      }, attrs), /*#__PURE__*/_react["default"].createElement(StyledChevronIcon, null)));
    }
  }, {
    key: "renderSlides",
    value: function renderSlides() {
      var _this$props3 = this.props,
        gap = _this$props3.gap,
        offset = _this$props3.offset,
        children = _this$props3.children;
      var count = _react["default"].Children.count(children);
      var handleScroll = (0, _defineProperty2["default"])({}, this.events.get('wheel'), this.syncScroll);
      return /*#__PURE__*/_react["default"].createElement(Slides, {
        ref: this.sliderRef,
        offset: offset,
        handleScroll: handleScroll
      }, _react["default"].Children.map(children, function (child, i) {
        var margin = Slider.getImageGap(i, count, gap);
        return child && ( /*#__PURE__*/_react["default"].cloneElement(child, {
          style: _objectSpread({}, margin)
        }));
      }));
    }
  }, {
    key: "renderDots",
    value: function renderDots() {
      var _this6 = this;
      var _this$state = this.state,
        slide = _this$state.slide,
        slidesCount = _this$state.slidesCount;
      return /*#__PURE__*/_react["default"].createElement(StyledDots, null, Array.from(Array(slidesCount).keys()).map(function (index) {
        return /*#__PURE__*/_react["default"].createElement(StyledDot, {
          key: index,
          functional: true,
          active: index === slide,
          "data-index": index,
          onClick: _this6.onDotClick
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        className = _this$props4.className,
        overlay = _this$props4.overlay;
      var scrollable = this.state.scrollable;
      return /*#__PURE__*/_react["default"].createElement(StyledContainer, {
        ref: this.containerRef,
        className: className
      }, /*#__PURE__*/_react["default"].createElement(StyledSlidesWrapper, null, this.renderSlides(), overlay && /*#__PURE__*/_react["default"].createElement(StyledOverlay, null)), scrollable && this.renderControls());
    }
  }], [{
    key: "getImageGap",
    value: function getImageGap(i, count, gap) {
      if (i === count - 1) {
        return {
          marginRight: 0
        };
      }
      return {
        marginRight: gap
      };
    }
  }]);
}(_react["default"].PureComponent);
Slider.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  controls: _propTypes["default"].bool,
  dots: _propTypes["default"].bool,
  duration: _propTypes["default"].number,
  easing: _propTypes["default"].string,
  gap: _propTypes["default"].number,
  offset: _propTypes["default"].number,
  overlay: _propTypes["default"].bool
};
Slider.defaultProps = {
  className: '',
  controls: true,
  dots: false,
  duration: 400,
  easing: 'linear',
  gap: 10,
  offset: 0,
  overlay: false
};
var Slides = /*#__PURE__*/_react["default"].memo( /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var offset = props.offset,
    handleScroll = props.handleScroll,
    children = props.children;
  return /*#__PURE__*/_react["default"].createElement(StyledSlidesScrollable, (0, _extends2["default"])({}, handleScroll, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement(StyledSlidesList, {
    offset: offset
  }, children));
}), function (prevProps, nextProps) {
  return prevProps.children === nextProps.children;
});
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "Slider__StyledContainer",
  componentId: "sc-xqmhe6-0"
})(["z-index:1;width:100%;height:auto;overflow:hidden;user-select:none;position:relative;padding-bottom:2px;"]);
var StyledSlidesWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Slider__StyledSlidesWrapper",
  componentId: "sc-xqmhe6-1"
})(["text-align:center;position:relative;"]);
var StyledOverlay = _styledComponents["default"].div.withConfig({
  displayName: "Slider__StyledOverlay",
  componentId: "sc-xqmhe6-2"
})(["background:rgba(0,0,0,.2);height:100%;left:0;position:absolute;top:0;z-index:1;"]);
var StyledSlidesScrollable = _styledComponents["default"].div.withConfig({
  displayName: "Slider__StyledSlidesScrollable",
  componentId: "sc-xqmhe6-3"
})(["overflow-x:auto;overflow-y:hidden;scrollbar-width:none;transform:translate3d(0,0,0);::-webkit-scrollbar{display:none;}"]);
var StyledSlidesList = _styledComponents["default"].div.withConfig({
  displayName: "Slider__StyledSlidesList",
  componentId: "sc-xqmhe6-4"
})(["height:100%;display:flex;position:relative;width:fit-content;text-align:left;justify-content:flex-start;padding:0 ", "px;"], function (props) {
  return props.offset;
});

// controls

var ControlsContainer = _styledComponents["default"].div.withConfig({
  displayName: "Slider__ControlsContainer",
  componentId: "sc-xqmhe6-5"
})(["display:flex;align-items:center;justify-content:space-between;margin-top:8px;"]);
var StyledControlsButton = _styledComponents["default"].button.withConfig({
  displayName: "Slider__StyledControlsButton",
  componentId: "sc-xqmhe6-6"
})(["border:none;cursor:pointer;padding:6px;--background-color:var(--white);background-color:var(--background-color);border-radius:var(--border-radius);:disabled{opacity:var(--disabled-opacity);cursor:default;}:hover:enabled{background:linear-gradient(0deg,rgba(0,0,0,var(--hover-alpha)) 0%,rgba(0,0,0,var(--hover-alpha)) 100%),var(--background-color);}:active:enabled{background:linear-gradient(0deg,rgba(0,0,0,var(--pressed-alpha)) 0%,rgba(0,0,0,var(--pressed-alpha)) 100%),var(--background-color);}"]);
var StyledChevronIcon = (0, _styledComponents["default"])(_ChevronRight["default"]).withConfig({
  displayName: "Slider__StyledChevronIcon",
  componentId: "sc-xqmhe6-7"
})(["", ";height:24px;path{fill:var(--grey1);}"], function (_ref2) {
  var $isRotated = _ref2.$isRotated;
  return $isRotated && (0, _styledComponents.css)(["transform:rotate(180deg)"]);
});

// Dots

var StyledDots = _styledComponents["default"].div.withConfig({
  displayName: "Slider__StyledDots",
  componentId: "sc-xqmhe6-8"
})(["text-align:center;width:100%;"]);
var StyledDot = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "Slider__StyledDot",
  componentId: "sc-xqmhe6-9"
})(["cursor:pointer;height:8px;outline:none;position:relative;width:28px;:before{background-color:var(--grey2);border-radius:6px;box-sizing:border-box;content:'';height:6px;left:0;margin-left:auto;margin-right:auto;position:absolute;right:0;top:0;transition:all 0.1s ease-in-out;width:8px;}", ""], function (props) {
  return props.active && (0, _styledComponents.css)([":before{padding:0 13px;}"]);
});
var _default = exports["default"] = Slider;